export default __webpack_public_path__ + "static/media/do_not_disturb.f315a1be.svg";